import React, { useRef } from 'react';
var VeltCommentBubbleCommentsCount = function (props) {
    var defaultCondition = props.defaultCondition, annotationId = props.annotationId, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-bubble-comments-count", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "annotation-id": annotationId }, children));
};
export default VeltCommentBubbleCommentsCount;
